import { Constant, ConstantWithDefault } from '@shared/constants/index'
import type { Nullable } from '@shared/util/types'
import MainTitleBlue from '@img/teacher/main-title-blue.png'
import MainTitleGreen from '@img/teacher/main-title-green.png'
import MainTitlePurple from '@img/teacher/main-title-purple.png'
import MainTitleGray from '@img/teacher/main-title-gray.png'
import MainTitleStar from '@img/teacher/main-title-star.png'
import type { FilterItem } from '@/api/svc'

export const THESIS_PAPER_TYPE = Object.freeze(new ConstantWithDefault({
  Degree: { label: '学位论文', value: 1 },
  Graduation: { label: '毕业论文', value: 2 },
}, { label: '全部', value: 0 }))

export const KEYWORD_TYPE = Object.freeze(
  new Constant({
    Name: { label: '学生姓名', value: 1, placeholder: '请输入学生姓名' },
    StudentNumber: { label: '学号', value: 2, placeholder: '请输入学号' },
    Title: { label: '论文题目', value: 3, placeholder: '请输入论文题目' },
  }),
)

export const DEFAULT_VALUE = ''
export const EMPTY_VALUE = -1
export const DEFAULT_SELECT_OPTION = Object.freeze({ name: '全部', key: DEFAULT_VALUE }) as Nullable<FilterItem>
export const DEFAULT_EMPTY_OPTION = Object.freeze({ name: '-', key: EMPTY_VALUE }) as Nullable<FilterItem>

export const SORT_TYPE = Object.freeze({
  DESC: 0,
  ASC: 1,
})
export const ORDER_BY = Object.freeze({
  ImportTime: 0,
  SubmitTime: 1,
})

export const ORDER_TYPE = Object.freeze(
  new Constant({
    SaveTime: { label: '保存时间倒序', value: 1, orderType: SORT_TYPE.DESC, order: 0 },
    SubmitTime: { label: '提交时间正序', value: 0, orderType: SORT_TYPE.ASC, order: 1 },
    Deadline: { label: '截止时间正序', value: 2, orderType: SORT_TYPE.ASC, order: 2 },
  }),
)

export const THESIS_AI_ADVISE_STATES = Object.freeze(
  new Constant({
    NotGenerated: { label: '未生成', value: 1 },
    Generating: { label: '生成中', value: 2 },
    Generated: { label: '已生成', value: 3 },
  }),
)

export const THESIS_STATES = Object.freeze(
  new Constant({
    NotAssociated: { label: '未关联', value: 0, description: '', className: '' },
    Modifying: { label: '学生修改中', value: 1, description: '学生修改中', className: '' },
    Approved: { label: '指导通过', value: 2, description: '指导通过', className: '' },
    NotAdvised: { label: '待提交', value: 3, description: '待提交指导', className: 'yellow' },
  }),
)

export const THESIS_DETAIL_TAB_TYPE = Object.freeze(
  new Constant({
    Advise: { label: '论文指导', value: 1 },
    Score: { label: '评分报告', value: 2 },
    Example: { label: '参考示例', value: 3 },
  }),
)

export const ADVISE_RESULT = Object.freeze(
  new Constant({
    Approved: { label: '通过', value: 1 },
    Rejected: { label: '不通过', value: 2 },
  }),
)

export const THESIS_ADVISE_TYPE = Object.freeze(
  new Constant({
    All: {
      label: '全部',
      value: 0,
      backgroundColor: '#E4EEFF',
      mainColor: '#2263E5',
      titleColor: '#2A58B3',
      inactiveColor: '#B3CCFF',
      icon: MainTitleBlue,
    },
    Review: {
      label: '总评',
      value: 1,
      backgroundColor: '#DBF7F7',
      mainColor: '#1CAEB0',
      titleColor: '#1CAEB0',
      inactiveColor: '#A1E4E6',
      icon: MainTitleGreen,
    },
    My: {
      label: '我添加的',
      value: 2,
      backgroundColor: '#EDEAFF',
      mainColor: '#7C66F3',
      titleColor: '#7C66F3',
      inactiveColor: '#C3B8FD',
      icon: MainTitlePurple,
    },
    Ignore: {
      label: '已删除',
      value: 3,
      backgroundColor: '#F2F3F5',
      mainColor: '#86909C',
      titleColor: '#86909C',
      inactiveColor: '#C9CDD4',
      icon: MainTitleGray,
    },
    Refinement: {
      label: '润色建议',
      value: 4,
      backgroundColor: '#EDEAFF',
      mainColor: '#6F5CED',
      titleColor: '#7C66F3',
      inactiveColor: '#C3B8FD',
      icon: MainTitleStar,
    },
    FullReview: {
      label: '全文总评',
      value: 5,
      backgroundColor: '#DBF7F7',
      mainColor: '#1CAEB0',
      titleColor: '#1CAEB0',
      inactiveColor: '#A1E4E6',
      icon: MainTitleGreen,
    },
  }),
)

export const DEFAULT_REVIEW_TYPE = -1000

// 总评类型
export const THESIS_ADVISE_REVIEW_TYPE_LIST = [110, 113, 118, 119, 121, 145, 1102, 1103, 1104,
  DEFAULT_REVIEW_TYPE]

// 标题类型
export const THESIS_COACH_TITLE_TYPE_LIST = [116, 174]

export const EDIT_ACTION = Object.freeze(
  new Constant({
    Modify: { label: '', value: -1 },
    NoAction: { label: '', value: 0 },
    Replace: { label: '替换选中', value: 1 },
    Insert: { label: '插入文末', value: 2 },
  }),
)

export const SAVE_STATUS = Object.freeze(
  new Constant({
    Save: { label: '保存', value: 1 },
    Saving: { label: '保存中', value: 2 },
    Success: { label: '最近保存', value: 3 },
  }),
)

export const RANGE_TYPE = Object.freeze(
  new Constant({
    All: { label: '无限制', value: 0 },
    UnassignedOrMine: { label: '无指导老师/指导老师是自己的数据', value: 1 },
  }),
)

export const THESIS_REFINEMENT_STATUS = Object.freeze(
  new Constant({
    Generating: { label: '生成中', value: 1 },
    Generated: { label: '已生成', value: 2 },
    Failed: { label: '生成失败', value: 3 },
  }),
)
